import { format, isValid, parseISO } from 'date-fns'

// Combines a date string (DD/MM/YYYY or YYYY-MM-DD) with a HH:MM time string into a
// naive ISO datetime string (YYYY-MM-DDTHH:MM:00) for backend payloads.
export const toIsoFromDateTimeParts = (date: string, time: string, withTimezone?: boolean) => {
  const hasSlash = date.includes('/')
  let yyyy = '', mm = '', dd = ''

  if (hasSlash) {
    const [d, m, y] = date.split('/')
    dd = d; mm = m; yyyy = y
  } else {
    const [y, m, d] = date.split('-')
    dd = d; mm = m; yyyy = y
  }

  const base = `${yyyy}-${mm}-${dd}T${time}:00`

  if (!withTimezone) return base

  const offsetMinutes = new Date().getTimezoneOffset()
  const sign = offsetMinutes <= 0 ? '+' : '-'
  const absMinutes = Math.abs(offsetMinutes)
  const hours = String(Math.floor(absMinutes / 60)).padStart(2, '0')
  const minutes = String(absMinutes % 60).padStart(2, '0')

  return `${base}${sign}${hours}:${minutes}`
}

// Splits an ISO/backend datetime string into its display date (dd/MM/yyyy) or time (HH:mm) part.
export const extractDateTime = (dateString?: string | null, type: 'date' | 'time' = 'date') => {
  if (!dateString) return ''

  const normalizedString = dateString.replace(' ', 'T').replace(' -', '-').replace(' +', '+')
  const parsed = parseISO(normalizedString)

  if (!isValid(parsed)) return ''

  return type === 'date' ? format(parsed, 'dd/MM/yyyy') : format(parsed, 'HH:mm')
}

export const getUserTimezoneFormatted = () => {
  const parts = new Intl.DateTimeFormat('pt-BR', { timeZoneName: 'long' }).formatToParts(new Date());
  const offsetParts = new Intl.DateTimeFormat('pt-BR', { timeZoneName: 'shortOffset' }).formatToParts(new Date());

  const name = parts.find(p => p.type === 'timeZoneName')?.value ?? '';
  const offset = offsetParts.find(p => p.type === 'timeZoneName')?.value ?? '';

  return offset ? `${name} (${offset})` : name;
};
